var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},_vm._l((4),function(item){return _c('div',{key:item,staticClass:"list-item topIn",style:({
      'animation-delay': ((500 * item) + "ms"),
      'animation-fill-mode':' backwards !important'
    })},[_c('img',{attrs:{"src":require("../assets/test2.png"),"alt":""}}),_vm._v(" "),_c('div',[_vm._v("秋")]),_vm._v(" "),_c('div',[_vm._v("233")])])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc3b606a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Test.vue
// module id = 1652
// module chunks = 0